import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import BestSellers from "@/pages/BestSellers";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function App() {
    // Remove any stray emergent badge if injected
    useEffect(() => {
        const id = setInterval(() => {
            const badge = document.getElementById("emergent-badge");
            if (badge) badge.remove();
        }, 500);
        return () => clearInterval(id);
    }, []);

    return (
        <div className="App">
            <CartProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/best-sellers" element={<BestSellers />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="*" element={<Home />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </CartProvider>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#0a0a0a",
                        color: "#fff",
                        border: "1px solid #d98a9a",
                    },
                }}
            />
        </div>
    );
}

export default App;
